<template>
  <section>
    <SkeletonView v-if="isLoading" height="30px" width="30px" />
    <TooltipView v-else type="is-dark" :label="$t('Share with facebook')">
      <i class="icon cls cls-social-facebook is-medium is-clickable" @click="onShare"></i>
    </TooltipView>
  </section>
</template>

<script>
import { ReferralShareClickedEventTracking } from '/@/modules/platformreferral/segmentevents/ReferralShareClickedEventTracking';
import { PlatformReferralSegmentEventProperties } from '/@/modules/platformreferral/constants/PlatformReferralSegmentEventProperties';
import TooltipView from '@/modules/core/ui/components/wrappers/TooltipView.vue';
import SkeletonView from '@/modules/core/ui/components/wrappers/SkeletonView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'DesktopFacebookPostReferral',
  components: { SkeletonView, TooltipView },
  props: {
    isLoading: {
      type: Boolean,
      default: true
    },
    referralLink: {
      type: String,
      required: true
    }
  },
  methods: {
    onShare() {
      ReferralShareClickedEventTracking.dispatch(
        PlatformReferralSegmentEventProperties.device.DESKTOP,
        PlatformReferralSegmentEventProperties.medium.FACEBOOK
      );
      // eslint-disable-next-line no-undef
      FB.ui({
        method: 'share',
        href: this.referralLink
      });
    }
  }
};
</script>
